import { ComponentPropsWithoutRef } from 'react';

export function Td(props: ComponentPropsWithoutRef<'td'>) {
  return (
    <td
      {...props}
      className="typography-body-xs text-grayscale300 [&>strong]:text-body-m-mobile md:[&>strong]:text-body-m-mobile [&>strong]:text-grayscale600 px-24 py-16"
    />
  );
}
